module.exports = __webpack_public_path__ + "static/media/david-sommers-resume-05-2020.74f7c34b.pdf";